import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

import { Button } from "../../../../../../components/Form";

export const GenerateCSVButton = styled(Button)(() => ({
  width: 135,
}));

const styles = makeStyles(() => ({
  iconButton: {
    cursor: "pointer",
  },
}));

export default styles;
